import { LOAD_ALL_QUOTES, LOAD_SINGLE_QUOTE } from "./QuoteList.saga";

export const loadAllQuotes = (payload) => ({
  type: LOAD_ALL_QUOTES.LOADING,
  payload,
});

export const loadSingleQuote = (payload) => ({
  type: LOAD_SINGLE_QUOTE.LOADING,
  payload,
});
